import {
  AccordionButton,
  AccordionItem as ReachAccordionItem,
  AccordionPanel,
} from '@reach/accordion';
import { FC } from 'react';
import styled from 'styled-components';

interface AccordionItemProps {
  title: string;
}

const Item = styled(ReachAccordionItem)`
  padding: 0 var(--space-1);
  border-bottom: 1px solid currentColor;

  &:first-child {
    border-top: 1px solid currentColor;
  }
`;

const Title = styled.h3`
  & + [data-state='open'] {
    padding-bottom: var(--space-1);
  }

  button {
    position: relative;
    display: block;
    width: 100%;
    padding: var(--space-1) 0;
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-xxx-small);
    text-align: left;

    &::after {
      position: absolute;
      top: calc(50% - 4px);
      right: 0;
      width: 8px;
      height: 8px;
      border: 3px solid currentColor;
      border-top: 0;
      border-left: 0;
      transform: rotate(45deg);
      content: '';

      [data-state='open'] & {
        transform: rotate(-135deg);
      }
    }
  }
`;

export const AccordionItem: FC<AccordionItemProps> = ({ title, children }) => {
  return (
    <Item>
      <Title>
        <AccordionButton>{title}</AccordionButton>
      </Title>
      <AccordionPanel>{children}</AccordionPanel>
    </Item>
  );
};
